<template>
  <div id="app">
    <a-config-provider :locale="locale"><router-view /></a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN
    }
  }
}
</script>

<style>
html, body, #app{
  height: 100%;
}
li{
  list-style: none;
}
a{
  text-decoration: none;
}
*{
  margin: 0;
  padding: 0;
}
.app-container{
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue